import {CheckoutType} from '../constants';
import {CheckoutTypeLabel} from '../locales';

export const getCheckoutsTypeLabel = (type: CheckoutType) =>
	CheckoutTypeLabel[type];

export default getCheckoutsTypeLabel;
